// 9fbef606107a605d69c0edbcd8029e5d
/* stylelint-disable no-descending-specificity */
import styled from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils';

export const StyledCarousel = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  .carousel-arrows {
    position: relative;
    height: auto;
    display: inline-flex;
    align-items: center;
    button {
      position: absolute;
      border-radius: 4px;
    }
    .left-arrow {
      background: url(${(props) => getIconPath('smallright', props)}) no-repeat center center;
      outline: none;
      height: 36px;
      width: 36px;
      border: none;
      cursor: pointer;
      left: 20px;
      transform: rotate(180deg);
      display: none;
      background-color: white;
      @media ${(props) => props.theme.mediaQuery.large} {
        display: block;
      }
    }
    .right-arrow {
      background: url(${(props) => getIconPath('smallright', props)}) no-repeat center center;
      outline: none;
      height: 36px;
      width: 36px;
      border: none;
      cursor: pointer;
      right: 20px;
      display: none;
      background-color: white;
      @media ${(props) => props.theme.mediaQuery.large} {
        display: block;
      }
    }
  }
`;

export const StyledScroll = styled.div`
  margin: 0px;
  display: flex;
  overflow-x: scroll;
  scroll-behavior: smooth;
  height: 100%;
  overflow-y: hidden;
  white-space: nowrap;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;
export const StyledGrid = styled.div`
  display: flex;
`;

export const StyledArrowRef = styled.div`
  ${(props) =>
    props.rightEnd
      ? `
    margin-right: 5px;
  `
      : ``}
`;
